import React, { useEffect, useState } from "react";
import {
  countryCodes,
  userRegistrationOtp,
} from "../../../services/MainApiDetails";
import { useNavigate } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";


const ForgotPassword = ({ ForgotPass }) => {
    const navigate = useNavigate();

  const [countryCode, setCountryCode] = useState("");
  const [defaultDialCode, setDefaultDialCode] = useState("+91");
  const [userPhone, setUserPhone] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [type, setType] = useState(1);
  const [otpRes, setOtpRes] = useState("");
  const [error, setError] = useState("")
  const [errors, setErrors] = useState({
    phone: "",
    email: "",

  });

  useEffect(() => {
    getCountryCodes();
  }, []);

  function getCountryCodes() {
    countryCodes({})
      .then((res) => {
        if (res.data.status === 1) {
          setCountryCode(res.data.result);
        }
      })
      .catch((err, message) => {
        console.log(err + message);
      });
  }
  function countryCodeFunction(item) {
    let cCode = countryCode.filter((single) => single.dial_code === item);
    setDefaultDialCode(cCode[0].dial_code);
  }
  function validateEmail() {
    var validation = false;

    let regex = /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/;
    validation = regex.test(userEmail);

    return validation;
  }
  function validatePhone() {
    var validation = false;

    let regex = /^(\+?[0-9]{2})?([0-9]{10})$/;
    validation = regex.test(userPhone);

    return validation;
  }
  function sendOtpUser() {
    // e.preventDefault();
    var valid = true;
    var message = [];
    let data;
    let code =defaultDialCode.split('+')


    // let cCodeNum = countryCodeObj[0].dial_code;
    if (type==1 && (userPhone === "" || !validatePhone()||userPhone.length <8 || userPhone.length >12)) {

      message.phone = "Invalid phone number";
      setErrors(message);
    }
    else if (type==1) {
      data = {
        phone: userPhone,
        country_code: code[1],
      };
    }
    if (type==2 &&( !userEmail || !validateEmail())) {
      message.email = "Invalid email address";
      setErrors(message);
    }
    else if (type==2){
      data = {
        email: userEmail.toLowerCase(),
      };
    }

      if (data) {
        userRegistrationOtp(data)
            .then((response) => {
              if (response.data.status === 1) {
                let otpResp = response.data.otp;
                localStorage.setItem("email",userEmail)
                localStorage.setItem("phone",userPhone)
                localStorage.setItem("country_code",code[1])
                setOtpRes(otpResp);
                ForgotPass(2);
              }
              else
              {
                setError(response.data.message)
              }
            })
            .catch((err, message) => {
              console.log(err + message);
            });
      }


    }

  return (
    <div className="mobileForgotPassword-card">
    <div className="mobileForgotPassword-form-top">
  <div className="mobileForgotPassword-title-row">
    <div className="mobileForgotPassword-backButton" onClick={() => navigate(-1)}>
      <ArrowBackIosIcon className="icon" />
    </div>
    <h6>{localStorage.webKey ? "Change Password" : "Forgot Password"}</h6>
  </div>
</div>
      <div className="mobileForgotPassword-form-bottom">
        <form action="">
          <div className="mobileForgotPassowrd-form-radio-wrapper">
            <div className="inputRadio">
              <input
                type="radio"
                id="mobile"
                name="forgot-password"
                onClick={()=>setType(1)}
                checked={(type == 1)?type:false}
              />
              <label for="mobile">Mobile</label>
            </div>

            <div className="inputRadio">
              <input
                type="radio"
                id="email"
                name="forgot-password"
                checked={(type == 2)?type:false}

                onClick={()=>setType(2)}
              />
              <label for="email">Email</label>
            </div>
          </div>
          <div className="mobileForgotPassword-input-wrapper">
            <div className="mobileForgotPassword-inputBox" style={{"display":(type ==1 )?"block":"none"}}>
              {/*<span>Email / Mobile</span>*/}
              <span> Mobile</span>
              <div className="mobileRegister-phoneInput-container">
                <select
                  onChange={(e) => countryCodeFunction(e.target.value)}
                  name="country-code"
                  id="country-code"
                >
                  {countryCode
                    ? countryCode.map((item) => (
                        <option
                          key={item._id}
                          value={item.dial_code}
                          selected={
                            item.dial_code == defaultDialCode ? "selected" : ""
                          }
                        >
                          {item.dial_code}
                        </option>
                      ))
                    : ""}
                </select>
                <input
                  type="number"
                  placeholder="Type here"
                  value={userPhone}
                  onChange={(e) => setUserPhone(e.target.value)}
                />
              </div>
              <span>{errors.phone}</span>
            </div>
            <div className="editNameModal-inputBox" style={{"display":(type ==2 )?"block":"none"}}>
              <span>Email ID</span>
              <input
                  type="text"
                  placeholder="Type here"
                  value={userEmail}
                  onChange={(e) => setUserEmail(e.target.value)}
              />
              <span>{errors.email}</span>
            </div>
          </div>
          <span style={{"color":"red"}}>{error}</span>

          <div className="mobileForgotPassword-signup-button">
            <button type="button" onClick={sendOtpUser}>CONFIRM</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
